module.exports = __webpack_public_path__ + "static/media/VMIPO_Login.46dab5a5.jpg";